import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Avatar from "../assets/avatar.jpg";
import Banner2 from "../assets/Banner2.jpg";
import Banner3 from "../assets/Banner3.jpg";

const banners = [
  { id: 1, image: Avatar, text: "Khóa học chất lượng cao" },
  { id: 2, image: Banner3, text: "Học phí trọn gói - Không lo phát sinh" },
  { id: 3, image: Banner2, text: "Đăng ký ngay hôm nay" },
];

export default function Hero() {
  const [current, setCurrent] = useState(0);
  const [prev, setPrev] = useState(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setPrev(current);
      setCurrent((prevIndex) => (prevIndex + 1) % banners.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [current]);

  return (
    <section className="relative h-[80vh] overflow-hidden">
      {/* Ảnh cũ (rời đi) */}
      {prev !== null && (
        <div
          key={`prev-${banners[prev].id}`}
          className="absolute top-0 left-0 w-full h-full bg-center bg-cover z-0 animate-slideOutLeft"
          style={{ backgroundImage: `url(${banners[prev].image})` }}
        >
          <div className="bg-black/50 w-full h-full flex items-center justify-center">
            <div className="text-center text-white px-6">
              <h2 className="text-4xl md:text-6xl font-bold mb-6">
                {banners[prev].text}
              </h2>
            </div>
          </div>
        </div>
      )}

      {/* Ảnh mới (vào) */}
      <div
        key={`current-${banners[current].id}`}
        className="absolute top-0 left-0 w-full h-full bg-center bg-cover z-10 animate-slideInRight"
        style={{ backgroundImage: `url(${banners[current].image})` }}
      >
        <div className="bg-black/50 w-full h-full flex items-center justify-center">
          <div className="text-center text-white px-6">
            <h2 className="text-4xl md:text-6xl font-bold mb-6">
              {banners[current].text}
            </h2>
            <Link to="/lien-he">
              <button className="px-6 py-3 bg-yellow-500 text-black font-semibold rounded-lg shadow-lg hover:bg-yellow-400 transition">
                Liên hệ tư vấn
              </button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
